unit UColorConfig;

interface

type
  TColorConfig = class
  private
    FButtonColor: Integer;
    FBackgroundColor: Integer;
    FFeiertagColor: Integer;
    FFeiertagNotActiveColor: Integer;
    procedure ClearValues;
    procedure SetValues(json: string);
    procedure SetBackgroundColor(const Value: Integer);
    procedure SetButtonColor(const Value: Integer);
    procedure SetFeiertagColor(const Value: Integer);
    procedure SetFeiertagNotActiveColor(const Value: Integer);
  public
    constructor Create; overload;
    constructor Create(json: string); overload;
    property BackgroundColor: Integer read FBackgroundColor write SetBackgroundColor;
    property ButtonColor: Integer read FButtonColor write SetButtonColor;
    property FeiertagColor: Integer read FFeiertagColor write SetFeiertagColor;
    property FeiertagNotActiveColor: Integer read FFeiertagNotActiveColor write SetFeiertagNotActiveColor;
  end;

implementation

uses
  Vcl.Graphics, Js;

{ TColorConfig }

procedure TColorConfig.ClearValues;
begin
  Self.BackgroundColor:=clSkyBlue;
  Self.ButtonColor:=clYellow;
  Self.FeiertagColor:=clMoneyGreen;
  Self.FeiertagNotActiveColor:=clCream;
end;

constructor TColorConfig.Create;
begin
  Self.ClearValues;
end;

constructor TColorConfig.Create(json: string);
begin
  Self.SetValues(json);
end;

procedure TColorConfig.SetBackgroundColor(const Value: Integer);
begin
  FBackgroundColor := Value;
end;

procedure TColorConfig.SetButtonColor(const Value: Integer);
begin
  FButtonColor := Value;
end;

procedure TColorConfig.SetFeiertagColor(const Value: Integer);
begin
  FFeiertagColor := Value;
end;

procedure TColorConfig.SetFeiertagNotActiveColor(const Value: Integer);
begin
  FFeiertagNotActiveColor := Value;
end;

procedure TColorConfig.SetValues(json: string);
var obj: TJsObject;
begin
  Self.ClearValues;
  obj:=TJsJson.parseObject(json);
  if obj['BackgroundColor']<>nil then
    Self.BackgroundColor:=Integer(obj['BackgroundColor']);
  if obj['ButtonColor']<>nil then
    Self.ButtonColor:=Integer(obj['ButtonColor']);
  if obj['FeiertagColor']<>nil then
    Self.FeiertagColor:=Integer(obj['FeiertagColor']);
  if obj['FeiertagNotActiveColor']<>nil then
    Self.FeiertagNotActiveColor:=Integer(obj['FeiertagNotActiveColor']);
end;

end.
